import React, { PropTypes } from 'react';
import Paper from 'material-ui/Paper';

const IconWithCount = ({
  count,
  style,
  onTouchTap,
  icon,
}) => {
  const digits = `${count}`.length;
  return (
    <div
      style={{ ...style, cursor: Boolean(onTouchTap) ? 'pointer' : 'inherit' }}
      onTouchTap={onTouchTap}
    >
      {React.cloneElement(icon, {
        style: { fill: 'rgba(0, 0, 0, 0.54)', height: '28px', width: '28px' },
      })}
      <Paper
        style={{
          display: count ? 'inline-block' : 'none',
          width: digits > 1 ? `25px` : '18px',
          height: '18px',
          color: 'white',
          borderRadius: digits > 1 ? `2px` : '9px',
          backgroundColor: 'red',
          lineHeight: '17px',
          textAlign: 'center',
          position: 'relative',
          top: '-10px',
          left: '-5px',
        }}
      >
        {count > 99 ? '99+' : count}
      </Paper>
    </div>
  );
};

IconWithCount.propTypes = {
  style: PropTypes.object,
  count: PropTypes.number,
  icon: PropTypes.node,
  showRedDot: PropTypes.bool,
  onTouchTap: PropTypes.func,
};

IconWithCount.defaultProps = {
  onTouchTap: () => {},
};

export default IconWithCount;



// WEBPACK FOOTER //
// ./src/app/components/app-bar/notification/icon-with-counter.jsx